import { render, staticRenderFns } from "./DialogPDF.vue?vue&type=template&id=7364f834"
import script from "./DialogPDF.vue?vue&type=script&lang=js"
export * from "./DialogPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports